import { cn } from "@/lib/utils";
import { Star } from "lucide-react";

export function renderHotelRatingStars(rating?: number, className?: string) {
  if (rating === null || rating === undefined) return null;

  return Array.from({ length: 5 }).map((_, index) => (
    <Star
      key={index}
      className={cn("h-3 w-3", className)}
      strokeWidth={0.7}
      fill={index < rating ? "#fab005" : "transparent"}
      stroke={index < rating ? "#fab005" : "#fab005"}
    />
  ));
}
